import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsTransportforirelandComponent } from './simple-icons-transportforireland.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsTransportforirelandComponent ],
    exports:      [ SimpleIconsTransportforirelandComponent ],
    bootstrap:    []
})
export class SimpleIconsTransportforirelandModule {}
